import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Check Call",
  "use": "icon-Check Call-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-Check Call\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.805 2.195a.667.667 0 0 1 .155.698l-3.784 10.48a.987.987 0 0 1-1.81.064l-1.934-3.87-3.87-1.934a.987.987 0 0 1 .065-1.809l10.48-3.784a.667.667 0 0 1 .698.155Zm-9.939 4.6 3.361 1.68c.13.064.234.169.298.298l1.68 3.361 3.019-8.358-8.358 3.018Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol